import { accordionEventTracking } from './accordion';
import { lendiAnalytics } from './analytics';
import { eventTracking } from './base';
import { buttonEventTracking } from './button';
import { checkboxEventTracking } from './checkbox';
import { dropdownEventTracking } from './dropdown';
import { formSubmitTracking } from './form';
import { menuEventTracking } from './menu';
import { messageEventTracking } from './message';
import { modalEventTracking } from './modal';
import { newApplicationEventTracking } from './newApplication';
import { pageTracking } from './page';
import { radioButtonEventTracking } from './radio';
import { tabEventTracking } from './tab';
import { toggleEventTracking } from './toggle';
import { tooltipEventTracking } from './tooltip';

const buildTracking = (analytics: ReturnType<typeof lendiAnalytics>) => {
  return {
    accordion: accordionEventTracking(analytics),
    button: buttonEventTracking(analytics),
    tab: tabEventTracking.bind(null, analytics),
    event: eventTracking.bind(null, analytics),
    page: pageTracking.bind(null, analytics),
    form: formSubmitTracking.bind(null, analytics),
    modal: modalEventTracking(analytics),
    radio: radioButtonEventTracking.bind(null, analytics),
    dropdown: dropdownEventTracking.bind(null, analytics),
    toggle: toggleEventTracking.bind(null, analytics),
    checkbox: checkboxEventTracking.bind(null, analytics),
    tooltip: tooltipEventTracking.bind(null, analytics),
    newApplication: newApplicationEventTracking.bind(null, analytics),
    menu: menuEventTracking(analytics),
    message: messageEventTracking(analytics),
  };
};

export default buildTracking;

export * from './base';
